<template>
  <v-dialog
    id="nav-signout-dialog"
    v-model="isOpen"
    width="300px"
    theme="light"
  >
    <template #activator="{ props }">
      <v-list-item
        v-bind="props"
        append-icon="fas fa-right-from-bracket"
        title="Sign Out"
      />
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Sign Out
      </v-card-title>
      <v-card-text> Are you sure you want to sign out? </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          variants="text"
          @click="handleSignout"
        >
          Sign Out
        </v-btn>
        <v-btn
          color="primary"
          variants="text"
          @click="isOpen = false"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "SignoutDialog",
  props: {
    signOut: Function,
    closeProfileList: Function,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  // watch: {
  //   isOpen() {
  //     this.closeProfileList();
  //   },
  // },
  methods: {
    // sign out of firebase and close modal
    handleSignout() {
      this.signOut();
      this.isOpen = false;
    },
  },
});
</script>

<style scoped>
#nav-signout-dialog {
  width: 300px;
}
</style>
